import { render } from "./quo_info.vue?vue&type=template&id=0a6020a3"
import script from "./quo_info.vue?vue&type=script&lang=js"
export * from "./quo_info.vue?vue&type=script&lang=js"

import "./quo_info.vue?vue&type=style&index=0&id=0a6020a3&lang=scss"

import exportComponent from "/Users/a/Desktop/app/pulizhenkong_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__